module.exports = __webpack_public_path__ + "static/media/art1.a6125264.png";